import React, { FC } from 'react';

const HomeIcon: FC = () => {
    return (
        <svg
            className="svg-inline"
            width="21"
            height="21"
            viewBox="0 0 21 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.6428 2.03631C10.3511 1.80398 9.93757 1.80398 9.64589 2.03631L3.05498 7.28632C2.86443 7.4381 2.75342 7.66844 2.75342 7.91206V16.1621C2.75342 16.766 2.98749 17.3489 3.41001 17.7816C3.83317 18.215 4.4112 18.4621 5.01806 18.4621H15.2706C15.8775 18.4621 16.4555 18.215 16.8786 17.7816C17.3012 17.3489 17.5352 16.766 17.5352 16.1621V7.91206C17.5352 7.66844 17.4242 7.4381 17.2337 7.28632L10.6428 2.03631ZM4.35342 16.1621V8.2976L10.1443 3.68484L15.9352 8.2976V16.1621C15.9352 16.3538 15.8607 16.5339 15.7339 16.6638C15.6077 16.7931 15.4406 16.8621 15.2706 16.8621H13.3229V12.7916C13.3229 11.036 11.8997 9.61279 10.1441 9.61279C8.38852 9.61279 6.96533 11.036 6.96533 12.7916V16.8621H5.01806C4.84803 16.8621 4.68099 16.7931 4.55479 16.6638C4.42797 16.5339 4.35342 16.3538 4.35342 16.1621ZM8.56533 16.8621H11.7229V12.7916C11.7229 11.9196 11.016 11.2128 10.1441 11.2128C9.27218 11.2128 8.56533 11.9196 8.56533 12.7916V16.8621Z"
                fill="#242A36"
            />
        </svg>
    );
};

export default HomeIcon;
